export const toCamel = (str: string) =>
  str
    .toLowerCase()
    .split(/\s+/)
    .map((word, idx) => (idx === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)))
    .join("");

export const capitalizeWord = (str: string) => {
  if (!str) return "";
  const lower = str.toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
};

export const truncateText = (name?: string, maxLength?: number): string => {
  if (!name) {
    return "";
  }

  if (name.length <= maxLength!) {
    return name;
  }

  return `${name.slice(0, maxLength!)}...`;
};
